import ReCaptchaComponent from "./ReCaptchaComponent";

export default ReCaptchaComponent;
